"use client";

import { usePathname } from "next/navigation";
import type { ComponentProps } from "react";
import Link from "@/components/ui/NavLink";
import { servicePageSlug } from "@/data/servicePages";

/**
 * Links to a service (or category) section on /services. Off /services it
 * navigates to /services#id; on /services it opens the tab and scrolls there.
 * With `landing`, services that have their own page (data/servicePages.ts)
 * link there instead - only the footer uses it.
 */
export default function ServiceLink({
  serviceId,
  landing = false,
  onClick,
  ...props
}: Omit<ComponentProps<typeof Link>, "href"> & { serviceId: string; landing?: boolean }) {
  const pathname = usePathname();
  const landingSlug = landing ? servicePageSlug(serviceId) : undefined;

  if (landingSlug) {
    return <Link {...props} onClick={onClick} href={`/services/${landingSlug}`} />;
  }

  return (
    <Link
      {...props}
      href={`/services#${serviceId}`}
      onClick={(e) => {
        onClick?.(e);
        if (pathname.replace(/\/$/, "") === "/services") {
          e.preventDefault();
          window.dispatchEvent(new CustomEvent("services:category", { detail: serviceId }));
        }
      }}
    />
  );
}
